import React, { Component } from "react";
import { connectStore } from "redux-box";
import {
  AlignContentHorizontal,
  EmptyContainer,
  AutoContainer,
  LoadingContainer,
  InfiniteScrollParentContainer,
  InfiniteScrollLoader,
} from "static/styled/custom.styled";
import {
  NavigationHeaderContainer,
  NavigationContainer,
} from "static/styled/NavigationBar.styled";
import { module as activity } from "@st/activity";
import { module as passages } from "@st/passages";
import { module as inviteCode } from "@st/inviteCode";
import swal from "sweetalert2";
import PassageCard from "./passage-card";
import InfiniteScroll from "react-infinite-scroller";
import { PASSAGES_HIDDEN_GRADES } from "../../../utils/constant";

class PassagesList extends Component {
  constructor(props) {
    super();
    this.state = {
      classList: [],
      grade: null,
    };
  }

  handleGradeChange = (grade) => {
    this.props.passages.setPassageList([]);
    this.props.passages.requestPassageListByGradeId(grade);
    this.setState({
      grade: grade.id,
    });
  };

  handlePublishClick = (e, passage) => {
    let value = null;
    if (passage.is_active) value = "deactivate";
    else value = "activate";
    swal({
      text: "Are you sure that you want to " + value + " this passage",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        this.props.passages.requestUpdatePassage({
          ...passage,
          is_active: !passage.is_active,
        });
      }
    });
    e.preventDefault();
    e.stopPropagation()
  };

  fetchMorePassages = () => {
    let { passages } = this.props;

    if (passages.passage_result !== null && passages.passage_result.has_next) {
      setTimeout(() => {
        if (
          passages.passage_result !== null &&
          passages.passage_result.next_page > 0
        )
          passages.requestConcatPassages(passages.passage_result.next_page);
      }, 100);
    }
  };

  render() {
    let passageList = this.props.passages.passageList;
    let classList =
      this.props.activity.grades &&
      this.props.activity.grades.filter((grade)=>!PASSAGES_HIDDEN_GRADES.includes(grade.name)).map((grade, i) => (
        <a
          key={i}
          className={
            this.props.passages.active_passage_grade &&
            grade.id === this.props.passages.active_passage_grade.id
              ? "active"
              : ""
          }
          onClick={() => this.handleGradeChange(grade)}
        >
          <span> {grade.name}</span>
        </a>
      ));

    let passagesList = (
      <AlignContentHorizontal marginBottom="70px">
        {passageList && passageList.length > 0 ? (
          passageList.map((passageInfo, index) => {
            return (
              <div className="col-sm-6 col-md-4 col-lg-3" key={index}>
                {/* <Link to={"/passages/edit/" + passageInfo.id}> */}
                <PassageCard
                  passageInfo={passageInfo}
                  // challengeId={activity.id}
                  handlePublishClick={(e) =>
                    this.handlePublishClick(e, passageInfo)
                  }
                />
                {/* </Link> */}
              </div>
            );
          })
        ) : (
          <EmptyContainer>
            <h4>NO PASSAGES FOR THIS GRADE</h4>
          </EmptyContainer>
        )}
      </AlignContentHorizontal>
    );
    return (
      <AutoContainer>
        <NavigationHeaderContainer zIndex={10} shadow>
          <NavigationContainer>{classList}</NavigationContainer>
        </NavigationHeaderContainer>
        {this.props.passages.fetch_passage_list ? (
          <LoadingContainer style={{ zIndex: "100" }}>
            <img
              alt="loading"
              width="60"
              height="60"
              src={require("static/img/Theme-loader.gif")}
            />
          </LoadingContainer>
        ) : (
          //<div>{readingChallengeList}</div>
          <InfiniteScrollParentContainer>
            <InfiniteScroll
              pageStart={0}
              loadMore={this.fetchMorePassages}
              style={{ position: "relative" }}
              hasMore={
                this.props.passages &&
                this.props.passages.passage_result &&
                this.props.passages.passage_result.has_next
              }
              loader={
                <InfiniteScrollLoader className="loader" key={0}>
                  <img
                    alt="loader"
                    width="50"
                    height="50"
                    src={require("static/img/Theme-loader.gif")}
                  />
                </InfiniteScrollLoader>
              }
              useWindow={false}
            >
              {passagesList}{" "}
            </InfiniteScroll>
          </InfiniteScrollParentContainer>
        )}
      </AutoContainer>
    );
  }
}

export default connectStore({ activity, passages, inviteCode })(PassagesList);
